import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import { Box, Stack, Typography } from "@mui/material";

import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useTranslation } from "@/translations";

import { SeizableIncomeCalculatorDialogProps } from "./SeizableIncomeCalculatorDialog.types";
import { TRANSLATION_BASE } from "./SeizableIncomeCalculatorDialog.utils";
import { SeizableIncomeInputs } from "./components/SeizableIncomeInputs";
import { SeizableIncomeResult } from "./components/SeizableIncomeResult";
import { useSeizableIncomeCalculator } from "./hooks/useSeizableIncomeCalculator";

export function SeizableIncomeCalculatorDialog({ onClose }: SeizableIncomeCalculatorDialogProps) {
  const { t } = useTranslation();
  const { formik, result, availablePeriods } = useSeizableIncomeCalculator();

  const title = (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <CalculateOutlinedIcon color="primary" fontSize="large" />
      <Box>
        <Typography variant="h1">{t(`${TRANSLATION_BASE}.title`)}</Typography>
        <Typography variant="subtitle1" color="text.secondary">
          {t(`${TRANSLATION_BASE}.subtitle`)}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <FormDialog
      title={title}
      onClose={onClose}
      formik={formik}
      confirmDirtyClose={false}
      disableErrorNotification
      cancelLabel={t(`${TRANSLATION_BASE}.close`)}
      paperSx={{ maxWidth: "760px", width: "100%" }}
    >
      <Stack direction="row" gap={3}>
        <SeizableIncomeInputs formik={formik} availablePeriods={availablePeriods} />
        <SeizableIncomeResult result={result} />
      </Stack>
    </FormDialog>
  );
}
